import type React from "react";

import type { UserCourseExercise } from "api/schemas/UserCourse";

import { ExerciseDetails } from "./ExerciseDetails";
import { ExerciseEditRow } from "./ExerciseEditRow";
import { getExerciseStatus } from "./UserCourseExercise";

interface Props {
  exercise: UserCourseExercise;
  currentProtocolWeek: number;
  onChangeEndWeek: (id: number, n: number | null) => void;
  onChangeLevel: (id: number, n: number) => void;
  onChangeWeek: (id: number, n: number) => void;
  onClose: () => void;
}

export const ExerciseEditPopup: React.FC<Props> = ({
  exercise,
  currentProtocolWeek,
  onChangeEndWeek,
  onChangeLevel,
  onChangeWeek,
  onClose,
}) => {
  const status = getExerciseStatus(exercise, currentProtocolWeek);

  return (
    <ExerciseDetails exercise={exercise} currentLevel={exercise.current_level} onClose={onClose}>
      <ExerciseEditRow
        status={status}
        exercise={exercise}
        currentProtocolWeek={currentProtocolWeek}
        onChangeEndWeek={onChangeEndWeek}
        onChangeLevel={onChangeLevel}
        onChangeWeek={onChangeWeek}
      />
    </ExerciseDetails>
  );
};
